// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dd174cd1","977":"38974fcb"}[chunkId] + ".chunk.js";
};